// Bridge between the Vue shell entry points and the persistent federated
// "New content" modal (content-studio React island mounted in Organization.vue).
// Opening is a fire-and-forget DOM CustomEvent so any entry point — Vue or React —
// can open the single shell-level modal. Keep this string in sync with
// content-studio's `OPEN_NEW_CONTENT_MODAL_EVENT`.
export const OPEN_NEW_CONTENT_MODAL_EVENT = 'cl:open-new-content-modal';

export function openNewContentModal(): void {
  document.dispatchEvent(new CustomEvent(OPEN_NEW_CONTENT_MODAL_EVENT));
}
